<template>
  <div class="location-selector">
    <div class="location-wrapper text-center">
      <el-button
        round
        @click="dialogFormVisible = true"
      >
        <i class="icon-place" />
        <template v-if="location">
          {{ location.formatted_address }}
        </template>
        <template v-else>
          {{ $t('filter.set-location.label') }}
        </template>
        <i class="icon-arrow-b" />
      </el-button>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form
        :label-position="labelPosition"
        :model="{}"
      >
        <el-form-item :label="$t('filter.choose-city.label')">
          <location @place_changed="dialogFormVisible = false" />
        </el-form-item>

        <!--<el-form-item class="km" v-if="location">-->
        <!--<select-primary-js-->
        <!--placeholder="Radius"-->
        <!--label="radius"-->
        <!--v-model="radius"-->
        <!--:item-key="'value'"-->
        <!--:searchable="false"-->
        <!--:options="radiusOptions">-->
        <!--</select-primary-js>-->
        <!--</el-form-item>-->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import mutations from '@/store/filters/filters.mutationlist';
// import { autoState } from '@fps/vue-toolkit/dist/util';
import { mapState } from 'vuex';
import Location from '@/components/MainLeftFilters/Location';

export default {
  components: {
    Location,
  },
  data() {
    return {
      labelPosition: 'top',
      dialogFormVisible: false,
    };
  },
  computed: {
    ...mapState({
      location: state => state.filters.location,
    }),
  },
  // methods: {
  //   onPlaceChanged(/* location */) {
  //     // console.log(location);
  //   },
  // },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/LocationSelect.vue